'use es6';

import { PureComponent, Fragment } from 'react';
import { Spacer } from 'foundations-components/components/Spacer';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { formatDateForDateInput, getFormatValueFromMetaData, getFormatTextFromMetaData, updateDateFormatMetaData, updateDefaultDate, getDateFieldValidationMessage } from 'FormsUI/utils/DateUtils';
import { getUISelectDateFormatOptions } from 'forms-utils-lib/date/getUISelectDateFormatOptions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import DateFormatPicker from 'ui-forms-components/fields/DateFormatPicker';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DefaultValuePicker = ({
  onChange,
  format,
  value,
  field,
  validationMessage
}) => /*#__PURE__*/_jsx(CommentableArea, {
  moduleId: `${getPropertyObjectTypeId(field)}-default-value`,
  description: {
    translationKey: 'formsDefaultValue'
  },
  children: /*#__PURE__*/_jsx("div", {
    "data-test-id": "config-input-field",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.form.config.defaultValue"
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.form.config.defaultValueToolTip"
      }),
      tooltipPlacement: "top right",
      validationMessage: validationMessage && /*#__PURE__*/_jsx(FormattedMessage, {
        message: validationMessage,
        options: {
          defaultValue: field.defaultValue
        }
      }),
      children: /*#__PURE__*/_jsx(DateInput, {
        use: "on-dark",
        format: format,
        value: value,
        onChange: onChange,
        "data-editable-field": "default-value"
      }, format)
    })
  })
});
export default class Date extends PureComponent {
  render() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(DefaultValuePicker, {
        format: getFormatTextFromMetaData(field),
        onChange: ({
          target: {
            value
          }
        }) => updateDefaultDate(field, update, value),
        value: formatDateForDateInput(field.defaultValue),
        validationMessage: getDateFieldValidationMessage(field.defaultValue),
        field: field
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(CommentableArea, {
        moduleId: `${getPropertyObjectTypeId(field)}-date-format`,
        description: {
          translationKey: 'formsDateFormat'
        },
        children: /*#__PURE__*/_jsx(DateFormatPicker, {
          onChange: evt => updateDateFormatMetaData(field, update, evt),
          FormControl: FormControl,
          value: {
            text: getFormatTextFromMetaData(field),
            value: getFormatValueFromMetaData(field)
          },
          getUISelectDateFormatOptions: getUISelectDateFormatOptions,
          labelKey: 'editor.form.config.selectDateFormat.label',
          tooltipKey: 'editor.form.config.selectDateFormat.tooltip',
          optionSeparatorTypesKey: 'editor.form.config.selectDateFormat.separatorTypes'
        })
      }), /*#__PURE__*/_jsx(Spacer, {}), this.props.ProfillingField]
    });
  }
}